exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h6[data-v-13b0925c]{color:#0d6348;font-weight:600}.text-muted[data-v-13b0925c]{font-size:.9rem}", ""]);

// exports
